import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { depositFormFields } from '../cryptoPaymentConstants'
import { CryptoPaymentDepositFormContent } from './CryptoPaymentDepositFormContent'
import { useCryptoPaymentModal } from '../CryptoPaymentModalProvider'
import { formatCurrencyAmount, getCurrencyConfigForWalletId, tokenizer } from '../../../services/utils'
import { useCasinoStore, usePlayerStore } from '../../../services/store'
import l10n from '../../i18n/I18N'
import { config } from '../../Init/Init'

export const CryptoPaymentDepositForm = () => {
  const playerStore = usePlayerStore()
  const playerWallets = playerStore.use.playerWallets()

  const casinoStore = useCasinoStore()
  const casinoCoinsToFiatRate = casinoStore.use.casinoCoinsToFiatRate()

  const { cryptoPaymentModalPackageAmount } = useCryptoPaymentModal()
  const gcCurrencyConfig = getCurrencyConfigForWalletId(playerWallets, config.gcWalletId)

  const validationSchema = Yup.object().shape({
    [depositFormFields.coinsAmount]: Yup.string().test(
      'min_deposit_amount',
      tokenizer(l10n.t['cryptopayment.deposit.gcAmount.minDeposit'], {
        '{depositCurrency}': gcCurrencyConfig.currencyName,
        '{depositAmount}': formatCurrencyAmount(config.gcToDollarExchangeRate * config.minimumUSDAmountToPurchase, 'GC')
      }),
      value => {
        const numberValue = Number(value?.replace(/,/g, ''))

        if (isNaN(numberValue)) {
          return true
        }

        return numberValue >= config.gcToDollarExchangeRate * config.minimumUSDAmountToPurchase
      }
    )
  })

  const initialValues = {
    [depositFormFields.coinsAmount]:
      cryptoPaymentModalPackageAmount && casinoCoinsToFiatRate.toCoins.GC
        ? formatCurrencyAmount(cryptoPaymentModalPackageAmount * casinoCoinsToFiatRate.toCoins.GC, 'GC')
        : '',
    [depositFormFields.cryptoAmount]: '',
    [depositFormFields.cryptoCurrencyCode]: '',
    [depositFormFields.address]: '',
    [depositFormFields.destinationTag]: ''
  }

  return (
    <Formik
      onSubmit={() => {}}
      validateOnChange={false}
      initialValues={initialValues}
      validationSchema={validationSchema}
    >
      <Form>
        <CryptoPaymentDepositFormContent />
      </Form>
    </Formik>
  )
}
